import React, { useState } from 'react';
import { ExternalLink, Play } from 'lucide-react';
import { resolveVideoSource } from '../lib/videoUrl';

const VideoReviewPlayer = ({ review }) => {
  const source = resolveVideoSource(review.video_url);
  const customPoster = review.poster_url?.trim() || '';
  const reviewer = review.reviewer_name?.trim() || 'Anonymous Client';
  const title = `Video testimonial from ${reviewer}`;
  const [embedStarted, setEmbedStarted] = useState(!customPoster);
  const [hasError, setHasError] = useState(false);

  if (source.type === 'embed') {
    if (customPoster && !embedStarted) {
      return (
        <button
          type="button"
          className="relative block h-full w-full overflow-hidden bg-black text-left"
          aria-label={`Play ${title}`}
          onClick={() => setEmbedStarted(true)}
        >
          <img src={customPoster} alt="" className="h-full w-full object-cover" loading="lazy" decoding="async" />
          <span
            aria-hidden="true"
            className="absolute inset-0 flex items-center justify-center bg-black/25 transition-colors hover:bg-black/40"
          >
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-purple-800 shadow-lg">
              <Play className="ml-1 h-6 w-6 fill-current" />
            </span>
          </span>
        </button>
      );
    }

    return (
      <iframe
        className="h-full w-full border-0"
        src={source.src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    );
  }

  if (hasError) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-purple-950 p-5 text-center text-white">
        <p className="text-sm">This video could not be played here.</p>
        <a
          href={source.src}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-purple-200 underline underline-offset-4"
        >
          Open video
          <ExternalLink aria-hidden="true" className="h-4 w-4" />
        </a>
      </div>
    );
  }

  return (
    <video
      className="h-full w-full object-cover"
      controls
      playsInline
      preload={customPoster ? 'metadata' : 'auto'}
      poster={customPoster || undefined}
      src={source.src}
      aria-label={title}
      onError={() => setHasError(true)}
    >
      Your browser does not support video playback.
    </video>
  );
};

export default VideoReviewPlayer;
